import { AnyConceptStatusesByCid, ConceptStatusValueType, FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import {
	ConceptStatusUpdate,
	getConceptStatusValue,
	RUlcerReviewItem,
	UlcerReviewConcept,
} from "@fusion-advantage/formlib"
import { FormRootState, FormThunk } from "../../redux/formStore"
import { err, ok, Result } from "neverthrow"
import z from "zod"
import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"
import { setFormModelUlcerReview } from "../../redux/formModelSlice"

export class UlcerReviewModelReduxPersister implements ComplexModelReduxPersister {
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch) => {
		const valueForCid = (cid: string) => getConceptStatusValue(statusesByCid[cid]) ?? []
		const rParse = z.array(RUlcerReviewItem).safeParse(valueForCid(UlcerReviewConcept.cid))
		if(!rParse.success) {
			return err(serializeFusionError('UlcerReviewModelReduxPersister rParse', rParse.error))
		}
		dispatch(setFormModelUlcerReview(rParse.data))
		return ok()
	}
	shouldSave(prevState: FormRootState, nextState: FormRootState): boolean {
		return prevState.formModel.ulcerReview !== nextState.formModel.ulcerReview
	}
	createStatusUpdates(nextState: FormRootState): ConceptStatusUpdate[] {
		return [{
			cid: UlcerReviewConcept.cid,
			value: nextState.formModel.ulcerReview,
			// must be .Chosen to be picked up by formDraftMiddleware
			// for auto draft save
			valueType: ConceptStatusValueType.Chosen,
		}]
	}
}
